import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.badge.has_badge}}
  <a href={{this.url}} class="check-display status-checked">{{d-icon
      "check"
    }}</a>
{{/if}}

{{#if this.canFavorite}}
  {{#if this.isFavorite}}
    <DButton
      @icon="star"
      @action={{this.onFavoriteClick}}
      class="favorite-btn"
    />
  {{else}}
    <DButton
      @icon="far-star"
      @action={{this.onFavoriteClick}}
      @title={{if
        this.canFavoriteMoreBadges
        "badges.favorite_max_not_reached"
        "badges.favorite_max_reached"
      }}
      @disabled={{not this.canFavoriteMoreBadges}}
      class="favorite-btn"
    />
  {{/if}}
{{/if}}

<div class="badge-contents">
  <PluginOutlet
    @name="badge-contents-top"
    @outletArgs={{hash badge=this.badge url=this.url}}
  />
  <a
    href={{this.url}}
    class="badge-icon {{this.badge.badgeTypeClassName}}"
  >{{icon-or-image this.badge}}</a>
  <div class="badge-info">
    <div class="badge-info-item">
      <h3><a href={{this.url}} class="badge-link">{{this.badge.name}}</a></h3>
      <div class="badge-summary">{{html-safe this.summary}}</div>

      {{#if this.displayCount}}

        <LinkTo
          @route="badges.show"
          @model={{this.badge}}
          class="badge-granted"
        >
          {{html-safe
            (i18n
              "badges.awarded"
              count=this.displayCount
              number=(number this.displayCount)
            )
          }}
        </LinkTo>

      {{/if}}
    </div>
  </div>
</div>
*/
{
  "id": "nVwD16Ll",
  "block": "[[[41,[30,0,[\"badge\",\"has_badge\"]],[[[1,\"  \"],[10,3],[15,6,[30,0,[\"url\"]]],[14,0,\"check-display status-checked\"],[12],[1,[28,[35,1],[\"check\"],null]],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"canFavorite\"]],[[[41,[30,0,[\"isFavorite\"]],[[[1,\"    \"],[8,[39,2],[[24,0,\"favorite-btn\"]],[[\"@icon\",\"@action\"],[\"star\",[30,0,[\"onFavoriteClick\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"    \"],[8,[39,2],[[24,0,\"favorite-btn\"]],[[\"@icon\",\"@action\",\"@title\",\"@disabled\"],[\"far-star\",[30,0,[\"onFavoriteClick\"]],[52,[30,0,[\"canFavoriteMoreBadges\"]],\"badges.favorite_max_not_reached\",\"badges.favorite_max_reached\"],[28,[37,3],[[30,0,[\"canFavoriteMoreBadges\"]]],null]]],null],[1,\"\\n\"]],[]]]],[]],null],[1,\"\\n\"],[10,0],[14,0,\"badge-contents\"],[12],[1,\"\\n  \"],[8,[39,4],null,[[\"@name\",\"@outletArgs\"],[\"badge-contents-top\",[28,[37,5],null,[[\"badge\",\"url\"],[[30,0,[\"badge\"]],[30,0,[\"url\"]]]]]]],null],[1,\"\\n  \"],[10,3],[15,6,[30,0,[\"url\"]]],[15,0,[29,[\"badge-icon \",[30,0,[\"badge\",\"badgeTypeClassName\"]]]]],[12],[1,[28,[35,6],[[30,0,[\"badge\"]]],null]],[13],[1,\"\\n  \"],[10,0],[14,0,\"badge-info\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"badge-info-item\"],[12],[1,\"\\n      \"],[10,\"h3\"],[12],[10,3],[15,6,[30,0,[\"url\"]]],[14,0,\"badge-link\"],[12],[1,[30,0,[\"badge\",\"name\"]]],[13],[13],[1,\"\\n      \"],[10,0],[14,0,\"badge-summary\"],[12],[1,[28,[35,7],[[30,0,[\"summary\"]]],null]],[13],[1,\"\\n\\n\"],[41,[30,0,[\"displayCount\"]],[[[1,\"\\n        \"],[8,[39,8],[[24,0,\"badge-granted\"]],[[\"@route\",\"@model\"],[\"badges.show\",[30,0,[\"badge\"]]]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,7],[[28,[37,9],[\"badges.awarded\"],[[\"count\",\"number\"],[[30,0,[\"displayCount\"]],[28,[37,10],[[30,0,[\"displayCount\"]]],null]]]]],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"if\",\"d-icon\",\"d-button\",\"not\",\"plugin-outlet\",\"hash\",\"icon-or-image\",\"html-safe\",\"link-to\",\"i18n\",\"number\"]]",
  "moduleName": "discourse/components/badge-card.hbs",
  "isStrictMode": false
});